import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  FormGroup,
  Label,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import moment from "moment";
import { Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";
import Select from "react-select";
import Async, { useAsync } from "react-select/async";

import DatePicker from "react-datepicker";
import "./myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import { Link } from "react-router-dom";
import axios from "axios";
import SaleTax from "../Tax/SaleTax/saleTax";
import { GetIp } from "./Get_ip";
import CreatableSelect from "react-select/creatable";
import ResponseLoader from "./ResponseLoader";

// import { getItemSubCategory } from "../../../../../node_backendAS/controllers/lovsController";

export default function SubRecipeFormComponent(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  const [checkitemCatChild, setCheckitemCatChild] = useState(false);
  const [errorItemCatChild, setErrorItemCatChild] = useState(false);
  const [errorItemSubCatChild, setErrorItemSubCatChild] = useState(false);
  const [checkitemSubCatChild, setCheckitemSubCatChild] = useState(false);
  const [checkItemTypeParent, setCheckItemTypeParent] = useState(false);
  const [checkItemCatParent, setCheckItemCatParent] = useState(false);
  const [checkItemSubCatParent, setCheckItemSubCatParent] = useState(false);
  const [checkUomTypeParent, setCheckUomTypeParent] = useState(false);
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [data, setData] = useState({
    itemAdd: "",
    // defaultDes: "",
    defaultQuan: "",
    defaultRate: "",
    defaultSalesTax: 0,
    showModalItemCategory: false,
    showModalItemSubCategory: false,
    // uom: [],
    itemCatDesc: "",
    itemCatCode: "",
    itemSubCatDesc: "",
    itemSubCatCode: "",
    itemType: "",
    itemCat: "",
    itemCatItemSub: "",
    // itemSubCat: "",
    defaultQuanShow: "",
    defaultRateShow: "",
    showModalAddNew: true,
    activity: props?.propData?.location?.rowData?.referencePk,
  });

  const handleCreate = async (inputValue, Name) => {
    setLoadingResponce(true);
    if (Name === "Item Type") {
      axios
        .post(
          `${baseurl}/masterData/getAddItemType`,
          {
            itemTypeName: inputValue,
            companyId: companyId,
            username: username,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then(function (response) {
          setLoadingResponce(false);
          axios
            .post(
              `${baseurl}/lovs/getItemType`,
              { companyId: companyId, username: username },
              {
                headers: {
                  authorization: token,
                },
              }
            )
            .then((response) => {
              let mydata = [];
              let responseData = response.data.data;
              let preSelectedOption = {};
              for (let loop = 0; loop < responseData.length; loop++) {
                mydata.push({
                  id: responseData[loop]["ITEM_TYPE_ID"],
                  label: `${responseData[loop]["ITEM_TYPE_DESC"]}`,
                });
                if (mydata[loop]?.label === inputValue) {
                  preSelectedOption = {
                    id: responseData[loop]["ITEM_TYPE_ID"],
                    label: `${responseData[loop]["ITEM_TYPE_DESC"]}`,
                  };
                  selectItemTypeEvent(preSelectedOption);
                }
              }

              setGetDataItemType({
                ...getDataItemType,
                itemTypeOptions: mydata,
              });

              swal({
                title: "Saved Successfully!",
                text: "Item Type Add",
                icon: "success",
              });
            })
            .catch((err) => {
              console.log(err);
            });

          // .then((value) => {
          // thisContex.getData();
          // thisContex.addToggle();
          // });
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    // await axios
    // .post(
    //   `${baseurl}/masterData/addVehicleMake`,
    //   {
    //     viMake: inputValue,
    //     companyId: companyId,
    //     username: username,
    //   },
    //   {
    //     headers: {
    //       authorization: token,
    //     },
    //   }
    // )
    // .then(function (response) {})
    // .catch(function (error) {
    //   console.log(error);
    // });
  };
  const openItemCategory = (pData) => {
    // if (pData) {
    //   setData({
    //     ...data,
    //     showModalItemCategory: !data.showModalItemCategory,
    //     itemCatDesc: "",
    //     itemCatCode: "",
    //     itemCat: pData,
    //   });
    // } else {
    setData({
      ...data,
      showModalItemCategory: !data.showModalItemCategory,
      itemCatDesc: "",
      itemCatCode: "",
    });
    // }
  };

  const openItemSubCategory = (pData) => {
    // if (pData) {
    //   setData({
    //     ...data,
    //     showModalItemSubCategory: !data.showModalItemSubCategory,

    //     itemSubCat: pData,
    //   });
    // } else {
    setData({
      ...data,
      showModalItemSubCategory: !data.showModalItemSubCategory,
      itemSubCatCode: "",
      itemSubCatDesc: "",
    });
    // }
  };
  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    let uomId = data.uom?.id;
    if (uomId) props.toggle(uomId);
    else props.toggle();
  };

  const inputEvent = (e) => {
    // console.log(e.target.value);
    const value = e.target.value;
    const name = e.target.name;
    setData({
      ...data,
      [name]: value,
    });
    // console.log(Number(value));
    // console.log(typeof Number(value));
    // if (
    //   name === "defaultRateShow" &&
    //   value === "1" &&
    //   Number(data.defaultRate) <= 0
    // ) {
    //   swal({
    //     title: "Default rate should be more than 0",
    //     text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
    //     icon: "warning",
    //   });
    //   setData({
    //     ...data,
    //     defaultRate: 1,
    //     [name]: value,
    //   });
    // } else {
    //   setData({
    //     ...data,
    //     [name]: value,
    //   });
    // }
  };
  const validNumber = (e) => {
    // console.log("in validNumber", e);
    let num = e.target.value?.toString().replaceAll(",", "");
    num = Number(num);
    // console.log("num" + num);
    if (num <= 0 && data.defaultRateShow === "1") {
      swal({
        title: "Default rate should be more than 0",
        text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
        icon: "warning",
      });
      setData({ ...data, defaultRate: 1 });
    } else {
      setData({
        ...data,
        defaultRate: num,
      });
    }
  };
  const selectUOMEvent = (...uomField) => {
    if (uomField[0] === null) {
      setCheckUomTypeParent(true);
    } else {
      setCheckUomTypeParent(false);
    }
    setData({
      ...data,
      uom: uomField[0],
    });
  };
  const selectItemTypeEvent = (...itemTypeField) => {
    setData({
      ...data,
      itemType: itemTypeField[0],
      itemCat: "",
      itemSubCat: "",
    });

    if (itemTypeField === null) {
      setCheckItemTypeParent(true);
      setCheckItemCatParent(true);
      setCheckItemSubCatParent(true);
      setErrorItemCatChild(true);
    } else {
      setCheckItemTypeParent(false);
      setErrorItemCatChild(false);
      // setCheckItemCatParent(true);
      // setCheckItemSubCatParent(true);
    }
    let itemCatdata = [];
    if (itemTypeField[0]?.id) {
      axios
        .post(
          `${baseurl}/lovs/getItemCategory`,
          {
            companyId: companyId,
            username: username,
            itemTypeId: itemTypeField[0]?.id,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((response) => {
          // console.log("response agy bai", response);
          let responseData = response.data.data;

          for (let loop = 0; loop < responseData.length; loop++) {
            itemCatdata.push({
              id: responseData[loop]?.id,
              label: `${responseData[loop]?.description}`,
            });
          }
          // console.log("itemCatdata", itemCatdata);
          setGetDataItemCat({ ...getDataItemCat, itemCatOptions: itemCatdata });
          // setData({
          //   ...data,
          //   itemCat:data.itemCat,
          //   itemSubCat:data.itemSubCat
          // })
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // axios
    // .post(
    //   `${baseurl}/lovs/getItemSubCategory`,
    //   { companyId: companyId, username: username },
    //   {
    //     headers: {
    //       authorization: token,
    //     },
    //   }
    // )
    // .then((response) => {
    //   // let mydata = [];
    //   let responseData = response.data.data;

    //   for (let loop = 0; loop < responseData.length; loop++) {
    //     itemSubCatdata.push({
    //       id: responseData[loop]["id"],
    //       label: `${responseData[loop]["description"]}`,
    //     });
    //   }

    //   setGetDataItemSubCat({
    //     itemSubCatOptions: itemSubCatdata,
    //   });
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
  };

  const selectItemCatEvent = (...itemCatField) => {
    setData({
      ...data,
      itemCat: itemCatField[0],
      itemSubCat: "",
      itemCatItemSub: itemCatField[0],
    });
    // console.log("itemCatField[0]", itemCatField[0]);
    let itemSubCatdata = [];
    if (itemCatField[0] === null) {
      setCheckItemCatParent(true);
    } else {
      setCheckItemCatParent(false);
    }
    if (itemCatField[0]?.id) {
      axios
        .post(
          `${baseurl}/lovs/getItemSubCategory`,
          {
            companyId: companyId,
            username: username,
            itemCatId: itemCatField[0]?.id,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((response) => {
          // let mydata = [];
          let responseData = response.data.data;

          for (let loop = 0; loop < responseData.length; loop++) {
            itemSubCatdata.push({
              id: responseData[loop]?.id,
              label: `${responseData[loop]?.description}`,
            });
          }

          setGetDataItemSubCat({
            ...getDataItemSubCat,
            itemSubCatOptions: itemSubCatdata,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const selectItemCatItemSub = (...itemCatField) => {
    if (itemCatField[0] === null) {
      setErrorItemSubCatChild(true);
    } else {
      setErrorItemSubCatChild(false);
    }
    setData({
      ...data,
      itemCatItemSub: itemCatField[0],
    });
  };

  const selectItemSubCatEvent = (...itemSubCatField) => {
    if (itemSubCatField[0] === null) {
      setCheckItemSubCatParent(true);
    } else {
      setCheckItemSubCatParent(false);
    }
    setData({
      ...data,
      itemSubCat: itemSubCatField[0],
    });
  };
  const selectSaleTaxEvent = (...saleTaxField) => {
    setData({
      ...data,
      defaultSalesTax: saleTaxField[0],
    });
  };
  const getItemSubCat = (pData, withIdCall_itemCat) => {
    let itemSubCatdata = [];
    // console.log(withIdCall_itemCat);
    // console.log(pData);
    axios
      .post(
        `${baseurl}/lovs/getItemSubCategory`,
        {
          companyId: companyId,
          username: username,
          // itemCatId: data.itemCat?.id ? data.itemCat?.id : withIdCall_itemCat,
          itemCatId: withIdCall_itemCat ? withIdCall_itemCat : data.itemCat?.id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // let mydata = [];
        let responseData = response.data.data;
        let objItemSubCat;

        for (let loop = 0; loop < responseData.length; loop++) {
          itemSubCatdata.push({
            id: responseData[loop]?.id,
            label: `${responseData[loop]?.description}`,
          });
          if (pData === responseData[loop]?.code) {
            objItemSubCat = {
              id: responseData[loop]?.id,
              label: `${responseData[loop]?.description}`,
            };
          }
        }

        setGetDataItemSubCat({
          ...getDataItemSubCat,
          itemSubCatOptions: itemSubCatdata,
        });
        if (objItemSubCat) {
          setData({
            ...data,
            itemSubCat: objItemSubCat,
            showModalItemSubCategory: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [getDataUom, setGetDataUom] = useState([]);
  const [getDataItemType, setGetDataItemType] = useState([]);
  const [getDataItemCat, setGetDataItemCat] = useState([]);
  const [getDataItemCatItemSub, setGetDataItemCatItemSub] = useState([]);
  const [getDataItemSubCat, setGetDataItemSubCat] = useState([]);
  const [getDataSaleTax, setGetDataSaleTax] = useState([]);
  useEffect(() => {
    let uomData = [];
    let itemTypedata = [];
    let itemCatdata = [];
    let itemSubCatdata = [];
    let saletaxData = [];

    // axios
    //   .post(
    //     `${baseurl}/lovs/getItemCategory`,
    //     { companyId: companyId, username: username, itemTypeId: "" },
    //     {
    //       headers: {
    //         authorization: token,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     console.log("response agy bai", response);
    //     let responseData = response.data.data;

    //     for (let loop = 0; loop < responseData.length; loop++) {
    //       itemCatdata.push({
    //         id: responseData[loop]["id"],
    //         label: `${responseData[loop]["description"]}`,
    //       });
    //     }
    //     console.log("itemCatdata", itemCatdata);
    //     setGetDataItemCatItemSub({
    //       itemCatOptionsItemSub: itemCatdata,
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .post(
        `${baseurl}/lovs/getUOM`,
        { username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // console.log(response);
        //  let uomData = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          uomData.push({
            id: responseData[loop]?.UOM_ID,
            label: `${responseData[loop]?.UOM_SHORT_DESC}`,
          });
        }

        setGetDataUom({ uomOptions: uomData });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(
        `${baseurl}/lovs/getItemType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // let mydata = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          itemTypedata.push({
            id: responseData[loop]?.ITEM_TYPE_ID,
            label: `${responseData[loop]?.ITEM_TYPE_DESC}`,
          });
        }

        setGetDataItemType({
          ...getDataItemType,
          itemTypeOptions: itemTypedata,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(
        `${baseurl}/taxSale/getSaleTaxMainData`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        // let  saletaxData = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          saletaxData.push({
            id: responseData[loop]?.STAX_GROUP_ID,
            label: `${responseData[loop]?.STAX_RATE}%`,
          });
        }
        setGetDataSaleTax({
          ...getDataSaleTax,
          defaultSalesTaxOptions: saletaxData,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    let itemCatobj, itemSubCatobj, itemTypeobj;

    if (props.EditData > -1) {
      lovsData();
      let tableId = props?.propData?.location?.rowData?.referencePk
        ? props?.propData?.location?.rowData?.referencePk
        : props.EditData;

      axios
        .post(
          `${baseurl}/masterData/getItemDataById`,
          { id: tableId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log(res.data.data[0]);
          let resData = res.data.data[0];
          let name = resData["ITEM_DESC"];
          let UOM = resData["UOM_ID"];
          let ItemType = resData["ITEM_TYPE_ID"];
          let saleTaxId = resData["STAX_GROUP_ID"];
          let defaultQuanShow = resData["ItemQtyShow"];
          let defaultRateShow = resData["ItemRateShow"];
          // console.log(saleTaxId);
          let uomobj, saleTaxobj;
          // for (let index = 0; index < uomData.length; index++) {
          //   console.log(uomData[index]);
          //   if (uomData[index].id === UOM) {
          //     console.log(uomData[index]);
          //     uomobj = {
          //       id: uomData[index].id,
          //       label: uomData[index].label,
          //     };
          //   }
          // }
          // for (let index = 0; index < itemTypedata.length; index++) {
          //   console.log(itemTypedata[index]);
          //   if (itemTypedata[index].id === ItemType) {
          //     console.log(itemTypedata[index]);
          //     itemTypeobj = {
          //       id: itemTypedata[index].id,
          //       label: itemTypedata[index].label,
          //     };
          //   }
          // }
          uomobj = {
            id: UOM,
            label: resData.UOM_SHORT_DESC,
          };

          itemTypeobj = {
            id: ItemType,
            label: resData.ITEM_TYPE_DESC,
          };
          itemCatobj = {
            id: resData.item_cat_id,
            label: resData.item_cat_desc,
          };
          itemSubCatobj = {
            id: resData.item_sub_cat_id,
            label: resData.item_sub_cat_desc,
          };
          for (let index = 0; index < saletaxData.length; index++) {
            // console.log(saletaxData[index]);
            if (saletaxData[index]?.id === saleTaxId) {
              // console.log(saletaxData[index]);
              saleTaxobj = {
                id: saletaxData[index]?.id,
                label: saletaxData[index]?.label,
              };
            }
          }
          // console.log("item type", itemTypeobj);
          // getItemCat(itemTypeobj.id);

          setData({
            ...data,
            itemAdd: name,
            defaultDes: resData["ITEM_CODE"],
            defaultQuan: resData["ItemQty"],
            defaultRate: resData["ItemRate"],
            defaultSalesTax: saleTaxobj,
            uom: uomobj,
            itemType: itemTypeobj,
            defaultQuanShow,
            defaultRateShow,
            itemSubCat: itemSubCatobj,
            itemCat: itemCatobj,
          });
          getItemCat(itemTypeobj?.id);

          getItemSubCat("", itemCatobj?.id);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
    }
  }, []);

  const getItemCat = (pItemTypeId, itemCatCode) => {
    // console.log(data.itemType);
    // console.log(data.itemType[0]);
    // console.log(data.itemType[0]?.id);
    axios
      .post(
        `${baseurl}/lovs/getItemCategory`,
        {
          companyId: companyId,
          username: username,
          itemTypeId: data.itemType?.id ? data.itemType?.id : pItemTypeId,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // console.log("response agy bai", response);
        let responseData = response.data.data;
        let itemCatdata = [];
        let objItemCat = {};
        for (let loop = 0; loop < responseData.length; loop++) {
          itemCatdata.push({
            id: responseData[loop]["id"],
            label: `${responseData[loop]["description"]}`,
          });
          if (itemCatCode === responseData[loop]?.code) {
            objItemCat = {
              id: responseData[loop]?.id,
              label: `${responseData[loop]?.description}`,
            };
          }
        }
        // console.log("itemCatdataheer", itemCatdata);
        // console.log("selct auoto item cat", itemCatdata);
        // setGetDataItemType({
        //   itemTypeOptions: itemCatdata,
        // });

        setGetDataItemCat({ ...getDataItemCat, itemCatOptions: itemCatdata });
        setGetDataItemCatItemSub({
          ...getDataItemCatItemSub,
          itemCatOptionsItemSub: itemCatdata,
        });

        if (objItemCat && !pItemTypeId) {
          setData({
            ...data,
            itemCat: objItemCat,
            itemCatItemSub: objItemCat,
            showModalItemCategory: false,
          });
          if (objItemCat?.id) {
            let itemSubCatdata = [];
            axios
              .post(
                `${baseurl}/lovs/getItemSubCategory`,
                {
                  companyId: companyId,
                  username: username,
                  itemCatId: objItemCat?.id,
                },
                {
                  headers: {
                    authorization: token,
                  },
                }
              )
              .then((response) => {
                // let mydata = [];
                let responseData = response.data.data;

                for (let loop = 0; loop < responseData.length; loop++) {
                  itemSubCatdata.push({
                    id: responseData[loop]?.id,
                    label: `${responseData[loop]?.description}`,
                  });
                }

                setGetDataItemSubCat({
                  ...getDataItemSubCat,
                  itemSubCatOptions: itemSubCatdata,
                });
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getUserIp = async function () {
    let res = await GetIp();
    // console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
    // setData({
    //   ...data,
    //   userIp: res.ip,
    //   userCountry: res.country,
    // });
  };
  const calculateTotalCost = (pQty, pCost) => {
    let qty = pQty ? pQty : 0;
    let cost = pCost ? pCost : 0;

    return qty * cost;
  };
  const lovsData = () => {
    axios
      .post(
        `${baseurl}/lovs/getUOM`,
        { username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // console.log(response);
        let mydata = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["UOM_ID"],
            label: `${responseData[loop]["UOM_SHORT_DESC"]}`,
          });
        }

        setGetDataUom({ uomOptions: mydata });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(
        `${baseurl}/lovs/getItemType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let mydata = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["ITEM_TYPE_ID"],
            label: `${responseData[loop]["ITEM_TYPE_DESC"]}`,
          });
        }

        setGetDataItemType({ ...getDataItemType, itemTypeOptions: mydata });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(
        `${baseurl}/taxSale/getSaleTaxMainData`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydata = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["STAX_GROUP_ID"],
            label: `${responseData[loop]["STAX_RATE"]}%`,
          });
        }
        setGetDataSaleTax({
          ...getDataSaleTax,
          defaultSalesTaxOptions: mydata,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleSubmitAddItem = async (event) => {
    // return;
    event.preventDefault();
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");
    const newRecord = { ...data };
    // console.log(newRecord);
    // console.log(companyId);
    // console.log(data.defaultSalesTax);
    // return;
    let { userIp, userCountry } = await getUserIp();
    if (data.itemType && data.itemCat && data.itemSubCat && data.uom) {
      if (props.EditData > -1) {
        // const { id } = this.state;
        let Id = props.EditData;
        // console.log(data.uom.id);
        // console.log(data.itemType.id);
        axios
          .post(
            `${baseurl}/masterData/updateItem`,
            {
              // itemAddE: itemAddE,
              id: Id,
              itemAdd: data.itemAdd,
              companyId,
              itemCat: data.itemCat?.id,
              itemSubCat: data.itemSubCat?.id,
              defaultDes: data.defaultDes,
              defaultQuan: data.defaultQuan.toString().replaceAll(",", ""),
              defaultRate: data.defaultRate.toString().replaceAll(",", ""),
              defaultQuanShow: data.defaultQuanShow,
              defaultRateShow: data.defaultRateShow,
              defaultSalesTax: data.defaultSalesTax?.id,
              uom: data.uom?.id,
              username: username,
              itemType: data.itemType?.id,
              userIp,
              userCountry,
              // username: username,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )

          .then(function (response) {
            setLoadingResponce(false);
            // console.log(response.data);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Success!",
                text: "Item Update!",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
                // thisContex.setState({
                //   tableData:[],
                // })
                // thisContex.updateModalToggle();
                // thisContex.getData();
              });
            }
            // return;
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        axios
          .post(
            `${baseurl}/masterData/getAddItem`,
            {
              itemAdd: data.itemAdd,
              companyId,
              defaultDes: data.defaultDes,
              defaultQuan: data.defaultQuan.toString().replaceAll(",", ""),
              defaultRate: data.defaultRate.toString().replaceAll(",", ""),
              defaultQuanShow: data.defaultQuanShow,
              defaultRateShow: data.defaultRateShow,
              defaultSalesTax: data.defaultSalesTax.id,
              uom: data.uom?.id,
              username: username,
              itemType: data.itemType?.id,
              itemCat: data.itemCat?.id,
              itemSubCat: data.itemSubCat?.id,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Item is Added",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      setLoadingResponce(false);

      if (!data.itemType) {
        setCheckItemTypeParent(true);
      }
      if (!data.itemCat) {
        setCheckItemCatParent(true);
      }
      if (!data.itemSubCat) {
        setCheckItemSubCatParent(true);
      }
      if (!data.uom?.id) {
        setCheckUomTypeParent(true);
      }
    }
  };

  const handleSubmitAddItemCat = async (event) => {
    event.preventDefault();
    setCheckitemCatChild(true);
    var companyId = localStorage.getItem("companyId");
    const newRecord = { ...data };
    // console.log(newRecord);
    // console.log(companyId);
    // console.log(data.defaultSalesTax);
    // return;
    if (props.EditData > -1) {
      // const { id } = this.state;
      // let Id = props.EditData;
      // console.log(data.uom.id);
      // console.log(data.itemType.id);
      // axios
      //   .post(
      //     `${baseurl}/masterData/updateItem`,
      //     {
      //       // itemAddE: itemAddE,
      //       id: Id,
      //       itemAdd: data.itemAdd,
      //       companyId,
      //       defaultDes: data.defaultDes,
      //       defaultQuan: data.defaultQuan.toString().replaceAll(",", ""),
      //       defaultRate: data.defaultRate.toString().replaceAll(",", ""),
      //       defaultQuanShow: data.defaultQuanShow,
      //       defaultRateShow: data.defaultRateShow,
      //       defaultSalesTax: data.defaultSalesTax.id,
      //       uom: data.uom.id,
      //       username: username,
      //       itemType: data.itemType.id,
      //       // username: username,
      //     },
      //     {
      //       headers: {
      //         authorization: token,
      //       },
      //     }
      //   )
      //   .then(function (response) {
      //     swal({
      //       title: "Success!",
      //       text: "Item Update!",
      //       icon: "success",
      //     }).then((value) => {
      //       toggleAddNew();
      //       // thisContex.setState({
      //       //   tableData:[],
      //       // })
      //       // thisContex.updateModalToggle();
      //       // thisContex.getData();
      //     });
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    } else {
      let { userIp, userCountry } = await getUserIp();
      if (data.itemCatDesc && data.itemCatCode !== null && data.itemType?.id) {
        axios
          .post(
            `${baseurl}/masterData/getAddItemCategory`,
            {
              companyId,
              catDesc: data.itemCatDesc,
              catCode: data.itemCatCode,
              username: username,
              itemType: data.itemType?.id,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            if (response.data.code === 501) {
              swal({
                title: "Invalid Operation",
                text: "Duplicate Code is Not Allowed",
                icon: "error",
              });
              setCheckitemCatChild(false);
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Item Category is Added",
                icon: "success",
              }).then((value) => {
                // let obj = {
                //   id: data.itemCatCode,
                //   value: data.itemCatCode,
                //   label: data.itemCatDesc,
                // };
                setCheckitemCatChild(false);
                openItemCategory();
                getItemCat("", data.itemCatCode);
              });
            }
          })
          .catch(function (error) {
            // console.log("erooor", error);
            // console.log("response", error.data.code);
            console.log(error.message);
            setCheckitemCatChild(false);
            // if (error.message === "Request failed with status code 501") {
            //   swal({
            //     title: "Invalid Operation",
            //     text: "Duplicate Entry Not Allowed",
            //     icon: "error",
            //   });
            // } else {
            swal({
              title: "Invalid Operation",
              text: "Something went wrong, try again",
              icon: "error",
            });
            // }
          });
      } else {
        setErrorItemCatChild(true);
        setCheckitemCatChild(false);
      }
    }
  };

  const handleSubmitAddItemSubCat = async (event) => {
    event.preventDefault();
    setCheckitemSubCatChild(true);
    var companyId = localStorage.getItem("companyId");
    const newRecord = { ...data };
    // console.log(newRecord);
    // console.log(companyId);
    // console.log(data.defaultSalesTax);
    // return;
    let { userIp, userCountry } = await getUserIp();
    if (props.EditData > -1) {
      // const { id } = this.state;
      // let Id = props.EditData;
      // console.log(data.uom.id);
      // console.log(data.itemType.id);
      // axios
      //   .post(
      //     `${baseurl}/masterData/updateItem`,
      //     {
      //       // itemAddE: itemAddE,
      //       id: Id,
      //       itemAdd: data.itemAdd,
      //       companyId,
      //       defaultDes: data.defaultDes,
      //       defaultQuan: data.defaultQuan.toString().replaceAll(",", ""),
      //       defaultRate: data.defaultRate.toString().replaceAll(",", ""),
      //       defaultQuanShow: data.defaultQuanShow,
      //       defaultRateShow: data.defaultRateShow,
      //       defaultSalesTax: data.defaultSalesTax.id,
      //       uom: data.uom.id,
      //       username: username,
      //       itemType: data.itemType.id,
      //       // username: username,
      //     },
      //     {
      //       headers: {
      //         authorization: token,
      //       },
      //     }
      //   )
      //   .then(function (response) {
      //     swal({
      //       title: "Success!",
      //       text: "Item Update!",
      //       icon: "success",
      //     }).then((value) => {
      //       toggleAddNew();
      //       // thisContex.setState({
      //       //   tableData:[],
      //       // })
      //       // thisContex.updateModalToggle();
      //       // thisContex.getData();
      //     });
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    } else {
      if (
        data.itemSubCatDesc &&
        data.itemSubCatCode !== null &&
        data.itemCatItemSub?.id
      ) {
        axios
          .post(
            `${baseurl}/masterData/getAddItemSubCategory`,
            {
              companyId,
              subCatDesc: data.itemSubCatDesc,
              subCatCode: data.itemSubCatCode,
              username: username,
              itemCat: data.itemCatItemSub?.id,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            if (response.data.code === 501) {
              swal({
                title: "Invalid Operation",
                text: "Duplicate Code is Not Allowed",
                icon: "error",
              });
              setCheckitemSubCatChild(false);
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Item Sub-Category is Added",
                icon: "success",
              }).then((value) => {
                // let obj = {
                //   id: data.itemSubCatCode,
                //   value: data.itemSubCatCode,
                //   label: data.itemSubCatDesc,
                // };
                setCheckitemSubCatChild(false);
                openItemSubCategory();
                getItemSubCat(data.itemSubCatCode);
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setCheckitemSubCatChild(false);

            swal({
              title: error.message,
              text: "Duplicate",
              icon: "error",
            });
          });
      } else {
        setErrorItemSubCatChild(true);
        setCheckitemSubCatChild(false);
      }
    }
  };
  return (
    <>
      {
        loadingResponce ? (
          <ResponseLoader />
        ) : (
          <div className="animated fadeIn">
            <Row className="Creative-Invoice-header-styling">
              <Col xs="6" className="card-header-Creative-Invoice">
                <>
                  <strong>
                    {/* <h4>{this.props.location.state?.updateCheck == 2  ? null : "Invoice" } {inv_book_id == 1 && postYn == 1 ? 'Invoice'}</h4> */}
                    {/* <h4>{(this.props.location.state?.updateCheck != 0 ||this.props.location.state?.updateCheck != 2) ? "Create Invoice" : {(this.props.location.state?.updateCheck == 0 && postYn ==0 && inv_book_id == 1) ? "Update":null}}</h4> */}
                    <h4>
                      {props.location.state?.updateCheck == 0 ? "Update " : ""}
                      Sub Recipe
                    </h4>
                  </strong>
                </>
              </Col>
              <Col xs="6" className="card-header-Creative-Invoice">
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <Link
                    to={{
                      pathname: props.location.state?.goBackUrl
                        ? props.location.state?.goBackUrl
                        : "/SubRecipeOverview",
                      // goBackStates: goBackStates,
                    }}
                    title={"Back to Overview"}
                    style={{
                      fontFamily: "Times New Roman",
                      fontWeight: "normal",
                      margin: "10px",
                    }}
                  >
                    <u className="Back-to-Overview">{"Back to Overview"}</u>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-left mx-2 icon-color"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                      />
                    </svg>
                  </Link>
                </div>
              </Col>
            </Row>
            <Row className="rowStyling">
              <Col>
                <div className="row">
                  <div className="col-md-12">
                    <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                      <div className="row ">
                        <div
                          translate="no"
                          className="col-md-12"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Item Type:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <div className="container">
                            <Row className="ml-1">
                              <Col md-4>
                                <Input
                                  type="radio"
                                  id="subRecipe"
                                  name="Radio"
                                  value="1"
                                  // onChange={onChangeRadio}
                                  defaultChecked
                                ></Input>
                                <Label htmlFor="subRecipe">Sub-Recipe</Label>
                              </Col>
                              <Col md-4>
                                <Input
                                  type="radio"
                                  id="menuItem"
                                  name="Radio"
                                  value="2"
                                  // onChange={onChangeRadio}
                                ></Input>
                                <Label htmlFor="menuItem">Menu Item</Label>
                              </Col>
                            </Row>
                          </div>
                        </div>

                        <div
                          translate="no"
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Item Code:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Select
                            isClearable
                            value={data.itemCode}
                            onChange={selectItemCatEvent}
                            options={getDataItemCat.itemCatOptions}
                            required
                            name="itemType"
                            // isDisabled={data.itemType?.id > 0 ? false : true}
                            placeholder={
                              localStorage.getItem("comp_lang") == "ur"
                                ? "--منتخب کریں--"
                                : localStorage.getItem("comp_lang") == "ar"
                                ? "--يختار--"
                                : "--select--"
                            }
                          />
                          {checkItemCatParent ? (
                            <div style={{ color: "red" }}>
                              <p>Please Select Item Code</p>
                            </div>
                          ) : null}
                        </div>

                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Item Name <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Input
                            type="text"
                            className="form-control"
                            name="itemName"
                            id="itemName"
                            onChange={inputEvent}
                            required
                            value={data.itemName}
                          />
                        </div>

                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Produced Quantity:
                          </Label>
                          <NumberFormat
                            style={{ textAlign: "right" }}
                            className="form-control"
                            name="producedQty"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.producedQty || "0.00"}
                            decimalScale={2}
                            // required
                          />
                        </div>
                        {/* //// */}
                        {/* <div translate="no" className="col-md-2"></div> */}
                        <div
                          translate="no"
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Code:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Select
                            isClearable
                            value={data.code}
                            onChange={selectItemCatEvent}
                            options={getDataItemCat.itemCatOptions}
                            required
                            name="code"
                            // isDisabled={data.itemType?.id > 0 ? false : true}
                            placeholder={
                              localStorage.getItem("comp_lang") == "ur"
                                ? "--منتخب کریں--"
                                : localStorage.getItem("comp_lang") == "ar"
                                ? "--يختار--"
                                : "--select--"
                            }
                          />
                          {checkItemCatParent ? (
                            <div style={{ color: "red" }}>
                              <p>Please Select Code</p>
                            </div>
                          ) : null}
                        </div>

                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Name <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Input
                            type="text"
                            className="form-control"
                            name="namee"
                            id="namee"
                            onChange={inputEvent}
                            required
                            value={data.namee}
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Unit:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="unit"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.unit}
                            disabled
                            // onBlur={(e) => {
                            //   validNumber(e);
                            // }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Quantity:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="quantity"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.quantity}
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Cost/Unit:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="costUnit"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.costUnit}

                            // onBlur={(e) => {
                            //   validNumber(e);
                            // }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Total:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="total"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.total}
                            disabled
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>

                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Waste %:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="wastePer"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.wastePer}
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Waste Quantity:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="wasteQty"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            disabled
                            value={data.wasteQty}
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Waste Amount:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            disabled
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="wasteAmt"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.wasteAmt}
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            Net Quantity:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="netQty"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.netQty}
                            disabled
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>
                        <div
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label style={{ fontWeight: "bold" }}>
                            NetCost:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <NumberFormat
                            className="form-control"
                            style={{ textAlign: "right" }}
                            name="netCost"
                            thousandSeparator={true}
                            placeholder="0.00"
                            onChange={inputEvent}
                            value={data.netCost}
                            disabled
                            onBlur={(e) => {
                              validNumber(e);
                            }}
                            // required
                          />
                        </div>
                        <div
                          translate="no"
                          className="col-md-4"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Order Type
                          </Label>
                          <Input
                            type="select"
                            className="form-control"
                            name="orderType"
                            id="orderType"
                            onChange={inputEvent}
                            value={data.orderType}
                          >
                            <option value="">All</option>
                            <option value="1">Din-In</option>
                            <option value="2">Take Away</option>
                            <option value="3">Delivery</option>
                          </Input>
                        </div>

                        <div className="col-md-6 col-lg-4">
                          <Label style={{ fontWeight: "bold" }}>
                            Last Updated:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>
                          <div className=" d-flex flex-row">
                            <DatePicker
                              className="form-control"
                              id="lastUpdated"
                              name="lastUpdated"
                              // selected={lastUpdated}
                              placeholderText="dd-mm-yyyy"
                              dateFormat="dd-MM-yyyy"
                              wrapperClassName="datePicker"
                              value={moment().format("YYYY-MM-DD")}
                              disabled
                              // onChange={(lastUpdated) => {
                              //   this.onChangeDatePickerEnd(lastUpdated);
                              // }}
                            />{" "}
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText className="calended_icon mb-0">
                                <i
                                  class="fa fa-calendar-plus-o"
                                  aria-hidden="true"
                                />
                              </InputGroupText>
                            </InputGroupAddon>
                          </div>
                        </div>

                        {/* {getDataSaleTax.defaultSalesTaxOptions?.length > 0 ? (
                          <div
                            translate="no"
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label
                              translate="yes"
                              style={{ fontWeight: "bold" }}
                            >
                              Default Sales Tax:
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Select
                              value={data.defaultSalesTax}
                              onChange={selectSaleTaxEvent}
                              options={getDataSaleTax.defaultSalesTaxOptions}
                              required
                              isClearable
                              name="defaultSalesTax"
                              placeholder={
                                localStorage.getItem("comp_lang") == "ur"
                                  ? "--منتخب کریں--"
                                  : localStorage.getItem("comp_lang") == "ar"
                                  ? "--يختار--"
                                  : "--select--"
                              }
                            />
                          </div>
                        ) : null}

                        <div
                          translate="no"
                          className="col-md-6"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            UOM Type:
                            <h8 style={{ color: "tomato" }}>*</h8>
                          </Label>

                          <Select
                            value={data.uom}
                            onChange={selectUOMEvent}
                            options={getDataUom.uomOptions}
                            required
                            name="uom"
                            placeholder={
                              localStorage.getItem("comp_lang") == "ur"
                                ? "--منتخب کریں--"
                                : localStorage.getItem("comp_lang") == "ar"
                                ? "--يختار--"
                                : "--select--"
                            }
                            isClearable
                          />
                          {checkUomTypeParent ? (
                            <div style={{ color: "red" }}>
                              <p>Please Select Uom Type</p>
                            </div>
                          ) : null}
                        </div> */}

                        {/* <div
                  className="col-md-6"
                  style={{ marginBottom: "12px" }}
                >
                  <Label style={{ fontWeight: "bold" }}>
                    Display Quantity on Invoice?
                  </Label>
                  <Input
                    type="select"
                    className="form-control"
                    name="defaultQuanShow"
                    id="defaultQuanShow"
                    onChange={inputEvent}
                    value={data.defaultQuanShow}
                  >
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </Input>
                </div> */}
                        {/* <div
                          translate="no"
                          className="col-md-6"
                          style={{ marginBottom: "12px" }}
                        >
                          <Label translate="yes" style={{ fontWeight: "bold" }}>
                            Display Rate on Invoice?
                          </Label>
                          <Input
                            type="select"
                            className="form-control"
                            name="defaultRateShow"
                            id="defaultRateShow"
                            onChange={inputEvent}
                            value={data.defaultRateShow}
                          >
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </Input>
                        </div> */}
                      </div>
                      <hr
                        style={{
                          border: "1px solid ",
                          marginBottom: "3vh",
                          marginTop: "3vh",
                          borderColor: "E4E5E6",
                        }}
                      />
                      <FormGroup>
                        <Button
                          // onClick={handleSubmitAddItem}
                          // type="submit"
                          className="mr-1 invoiceSubmitButton "
                        >
                          {props.EditData > -1 ? "Update" : "Save"} Changes
                        </Button>
                        <Button
                          onClick={() => toggleAddNew()}
                          className="mr-1"
                          size="sm"
                        >
                          Cancel
                        </Button>
                      </FormGroup>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )
        // (
        //     <div>
        //       <Modal
        //         show={data.showModalAddNew}
        //         size="lg"
        //         className="myModal"
        //         onHide={toggleAddNew}
        //         backdrop="static"
        //       >

        //         <Modal.Body>

        //         </Modal.Body>
        //       </Modal>
        //       <Modal
        //         show={data.showModalItemCategory}
        //         size="md"
        //         onHide={openItemCategory}
        //         backdrop="static"
        //       >
        //         <Modal.Header
        //           closeButton
        //           onClick={openItemCategory}
        //           className=" Creative-Invoice-header-styling"
        //         >
        //           <strong>
        //             <h4> Add Item Category </h4>
        //           </strong>
        //         </Modal.Header>
        //         <Modal.Body>
        //           <Row>
        //             <Col>
        //               <Form name="simpleForm" onSubmit={handleSubmitAddItemCat}>
        //                 <div className="row">
        //                   <div
        //                     className="col-md-12"
        //                     style={{ marginBottom: "12px" }}
        //                   >
        //                     <Label style={{ fontWeight: "bold" }}>
        //                       Item Type:
        //                       <h8 style={{ color: "tomato" }}>*</h8>
        //                     </Label>

        //                     <Select
        //                       key={JSON.stringify(data.itemType)}
        //                       value={data.itemType}
        //                       onChange={selectItemTypeEvent}
        //                       options={getDataItemType.itemTypeOptions}
        //                       required
        //                       name="itemType"
        //                       isClearable
        //                       placeholder={"-- Select --"}
        //                     />

        //                     {errorItemCatChild ? (
        //                       <div style={{ color: "red" }}>
        //                         <p>Please Select Item Type</p>
        //                       </div>
        //                     ) : null}
        //                   </div>
        //                   <div className="col-md-6">
        //                     <Label style={{ fontWeight: "bold" }}>
        //                       Item Category Code
        //                     </Label>
        //                     <Input
        //                       type="text"
        //                       className="form-control"
        //                       name="itemCatCode"
        //                       id="itemCatCode"
        //                       onChange={inputEvent}
        //                       value={data.itemCatCode}
        //                       required
        //                     />
        //                   </div>
        //                   <div
        //                     className="col-md-6"
        //                     style={{ marginBottom: "12px" }}
        //                   >
        //                     <Label style={{ fontWeight: "bold" }}>
        //                       Item Category Description
        //                     </Label>
        //                     <Input
        //                       type="text"
        //                       className="form-control"
        //                       name="itemCatDesc"
        //                       id="itemCatDesc"
        //                       onChange={inputEvent}
        //                       value={data.itemCatDesc}
        //                       required
        //                     />
        //                   </div>
        //                 </div>
        //                 <Button
        //                   // onClick={handleSubmitAddItem}
        //                   type="submit"
        //                   className="mr-1 invoiceSubmitButton "
        //                   disabled={checkitemCatChild}
        //                 >
        //                   Save Changes
        //                 </Button>
        //               </Form>
        //             </Col>
        //           </Row>
        //         </Modal.Body>
        //       </Modal>
        //       <Modal
        //         show={data.showModalItemSubCategory}
        //         size="md"
        //         onHide={openItemSubCategory}
        //         backdrop="static"
        //       >
        //         <Modal.Header
        //           closeButton
        //           onClick={openItemSubCategory}
        //           className=" Creative-Invoice-header-styling"
        //         >
        //           <strong>
        //             <h4> Add Item Sub-Category </h4>
        //           </strong>
        //         </Modal.Header>
        //         <Modal.Body>
        //           <Row>
        //             <Col>
        //
        //               <Form name="simpleForm" onSubmit={handleSubmitAddItemSubCat}>
        //                 <div className="row">
        //                   <div
        //                     className="col-md-12"
        //                     style={{ marginBottom: "12px" }}
        //                   >
        //                     <Label style={{ fontWeight: "bold" }}>
        //                       Item Category:
        //                       <h8 style={{ color: "tomato" }}>*</h8>
        //                     </Label>

        //                     <Select
        //                       isClearable
        //                       value={data.itemCatItemSub}
        //                       onChange={selectItemCatItemSub}
        //                       options={getDataItemCatItemSub.itemCatOptionsItemSub}
        //                       required
        //                       name="itemType"
        //                       placeholder={"-- Select --"}
        //                     />
        //                     {errorItemSubCatChild ? (
        //                       <div style={{ color: "red" }}>
        //                         <p>Please Select Item Category</p>
        //                       </div>
        //                     ) : null}
        //                   </div>
        //                   <div className="col-md-6">
        //                     <Label style={{ fontWeight: "bold" }}>
        //                       Sub-Category Code
        //                     </Label>
        //                     <Input
        //                       type="text"
        //                       className="form-control"
        //                       name="itemSubCatCode"
        //                       id="itemSubCatCode"
        //                       onChange={inputEvent}
        //                       value={data.itemSubCatCode}
        //                       required
        //                     />
        //                   </div>
        //                   <div
        //                     className="col-md-6"
        //                     style={{ marginBottom: "12px" }}
        //                   >
        //                     <Label style={{ fontWeight: "bold" }}>
        //                       Sub Category Description
        //                     </Label>
        //                     <Input
        //                       type="text"
        //                       className="form-control"
        //                       name="itemSubCatDesc"
        //                       id="itemSubCatDesc"
        //                       onChange={inputEvent}
        //                       value={data.itemSubCatDesc}
        //                       required
        //                     />
        //                   </div>
        //                 </div>
        //                 <Button
        //                   // onClick={handleSubmitAddItem}
        //                   type="submit"
        //                   className="mr-1 invoiceSubmitButton "
        //                   disabled={checkitemSubCatChild}
        //                 >
        //                   Save Changes
        //                 </Button>
        //               </Form>
        //             </Col>
        //           </Row>
        //         </Modal.Body>
        //       </Modal>
        //     </div>
        //   )
      }
    </>
  );
}
